import YandexCloudLogo from './../../assets/icons/YandexCloud.svg?react'

const YandexCloud = () => {
    return (
        <a href="https://yandex.cloud/ru/security" target="_blank">
            <YandexCloudLogo />
        </a>
    )
}

export default YandexCloud
